import { CookieBanner } from "./components/CookieBanner";
import Footer from "./components/Footer";
import Header from "./components/Header";
import WhatsAppButton from "./components/WhatsAppButton";
import { useGTMPageView } from "./hooks/useGTMPageView";
import { MainRoutes } from "./routes/mainRoutes";

const App = () => {
  useGTMPageView();

  return (
    <>
      <Header />
      <MainRoutes />
      <CookieBanner />
      <WhatsAppButton />
      <Footer />
    </>
  );
};

export default App;
